import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
const navItems = [{
  label: 'Browse All',
  path: '/inventory'
}, {
  label: 'Bags and Backpacks',
  path: '/inventory/bags-backpacks'
}, {
  label: 'Clothing',
  path: '/inventory/clothing'
}, {
  label: 'Fire Retardants',
  path: '/inventory/fire-retardants'
}, {
  label: 'Public Order / Control and Restraint',
  path: '/inventory/public-order'
}, {
  label: 'Tactical Vests',
  path: '/inventory/tactical-vests'
}, {
  label: 'Training Equipment',
  path: '/inventory/training-equipment'
}];
export function InventoryNav() {
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [showLeftFade, setShowLeftFade] = useState(false);
  const [showRightFade, setShowRightFade] = useState(true);
  // Check if a specific tab is active
  const isActive = (path: string) => {
    if (path === '/inventory') {
      // Active if exactly /inventory (Browse All)
      return location.pathname === '/inventory';
    }
    // Active if the path includes the category slug (handles product pages too)
    return location.pathname.includes(path);
  };
  const checkScroll = () => {
    if (scrollRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollRef.current;
      setShowLeftFade(scrollLeft > 0);
      // Use a small buffer (1px) for float precision issues
      setShowRightFade(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };
  // Initial check and event listener
  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
      return () => {
        el.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
      };
    }
  }, []);
  // Scroll active tab into view on mobile
  useEffect(() => {
    if (scrollRef.current) {
      const activeTab = scrollRef.current.querySelector('[data-active="true"]');
      if (activeTab) {
        activeTab.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [location.pathname]);
  return <div className="sticky top-[72px] z-40 bg-white border-b border-steel-200 shadow-sm" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-94">
        {/* Left Fade Indicator */}
        <div className={`absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none transition-opacity duration-300 ${showLeftFade ? 'opacity-100' : 'opacity-0'}`} data-id="element-95" />

        {/* Right Fade Indicator */}
        <div className={`absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none transition-opacity duration-300 ${showRightFade ? 'opacity-100' : 'opacity-0'}`} data-id="element-96" />

        <div ref={scrollRef} className="flex items-center gap-1 overflow-x-auto scrollbar-hide -mx-4 px-4 sm:mx-0 sm:px-0 snap-x snap-mandatory" data-id="element-97">
          {navItems.map(item => {
          const active = isActive(item.path);
          return <Link key={item.path} to={item.path} data-active={active} className={`
                  flex-shrink-0 px-4 py-3 text-sm font-semibold border-b-2 transition-colors whitespace-nowrap snap-start
                  ${active ? 'border-cg-orange-600 text-cg-orange-600' : 'border-transparent text-steel-500 hover:text-navy-900 hover:border-steel-300'}
                `} data-id="element-98">
                {item.label}
              </Link>;
        })}
        </div>
      </div>
    </div>;
}